// TODO move to constants & add groups to object
export const routeNames = {
    home: '/',
    homeTest: '/home',
    search: '/search',
    food: '/food',
    documents: '/documents',
    places: '/places', // retired page — redirects to `chains` (see pages/NewTopChains/Places.tsx)
    viewDocument: '/view-document',
    topChains: '/topChains',
    fireflyChains: '/fireflyChains',
    chains: '/chains',
    chainDetails: '/chainDetails',
    error: '/404',
    error2: '/500',
    myDocuments: '/myDocuments',
    projects: '/project',
    documentType: '/documentType',
    allMacs: '/allMacs', // deprecated, redirects to trendingNow
    trendingNow: '/trending-now',
    instantCharts: '/instantCharts',
    packages: '/packages',
    groups: '/groups',
    workspace: '/workspace/:workspaceId',
    categoryProfile: '/categoryProfile/:id',
    test: '/test'
};